import { Link } from 'react-router-dom';
import React from 'react';
export const Logo = ({
  className = ''
}) => {
  return <Link to="/" data-id="element-407">
      <img src="https://s3.us-east-1.amazonaws.com/cdn.getpoln.com/creatorboost/CBLogo.png" alt="CreatorBoost Logo" className={`h-24 ${className}`} data-id="element-408" />
    </Link>;
};